import api from '../api';

import { experienceApiRoutes } from './const';

export type StudentChannel = {
  type: 'email' | 'phone';
  masked: string;
  value: string;
};

/**
 * Resolve a student/registration number to the masked contact channels on the
 * matching user's profile.
 *
 * `accountExists` lets the caller distinguish an unknown identifier (`false`,
 * empty channels) from a real account that has no recovery channel on file
 * (`true`, empty channels) so the latter can be shown a "contact your
 * institution" message instead of a generic "not found".
 */
export const getStudentIdentifierChannels = async (
  identifier: string
): Promise<{ accountExists: boolean; channels: StudentChannel[] }> =>
  api
    .post(`${experienceApiRoutes.prefix}/student-identifier-channels`, {
      json: { identifier },
    })
    .json<{ accountExists: boolean; channels: StudentChannel[] }>();
